import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './Badge.themes';
export type BadgeProps = {
  alt?: string;
  className?: string;
  iconName?: IconName;
  iconSize?: string;
  label?: string | ReactNode;
  theme?: ThemeKey<typeof themes>;
  variant?: 'diamond' | 'pill';
};
export const Badge = ({
  alt,
  className,
  iconName,
  iconSize,
  label,
  theme = 'default',
  variant,
  ...rest
}: BadgeProps) => {
  if (!iconName && !label) {
    return null;
  }

  const { thIcon, thIconSize, thLabel, thRoot } = themes[theme]({
    variant,
  }) as DefaultThemeStyles<typeof themes>;
  return (
    <span {...rest} className={classnames(thRoot, className)}>
      {!!iconName && (
        <span className={thIcon}>
          <Icon alt={alt} name={iconName} width={iconSize || thIconSize} />
        </span>
      )}
      {!!label && <span className={thLabel}>{label}</span>}
    </span>
  );
};
